import { request } from "../client";

import type {
  TextQualityReport,
  TextQualitySave,
  TextQualityScan,
} from "@lingoshade/domain";

export function createAdminTextQualityEndpoints(baseUrl: string): {
  scan: (
    includeUserTexts: boolean,
    cursor: string | undefined,
    token: string,
  ) => Promise<TextQualityScan>;
  get: (id: string, token: string) => Promise<TextQualityReport>;
  save: (
    id: string,
    data: TextQualitySave,
    token: string,
  ) => Promise<TextQualityReport>;
} {
  return {
    scan: (includeUserTexts, cursor, token): Promise<TextQualityScan> =>
      request(baseUrl, "/admin/text-quality/scan", {
        method: "POST",
        body: { includeUserTexts, cursor },
        token,
      }),
    get: (id, token): Promise<TextQualityReport> =>
      request(baseUrl, `/admin/text-quality/${encodeURIComponent(id)}`, {
        token,
      }),
    save: (id, data, token): Promise<TextQualityReport> =>
      request(baseUrl, `/admin/text-quality/${encodeURIComponent(id)}`, {
        method: "PUT",
        body: data,
        token,
      }),
  };
}
